import React from 'react';
const RelatedLinks = () => {
  const relatedLinks = [
    {
      title: 'Hitung Usia Anda',
      url: '/calculator/id/agegregorian/',
    },
    {
      title: 'Penghitung Tasbih dan Istigfar',
      url: '/calculator/id/tally-counter/',
    },
    {
      title: 'Cek Apakah Berat Badan Anda Sesuai dengan Tinggi Badan',
      url: '/calculator/id/bmiadults/',
    },
    {
      title: 'Kalkulator Siklus Menstruasi',
      url: '/calculator/id/period/',
    },
    {
      title: 'Hitung Apakah Anda Wajib Membayar Zakat',
      url: '/calculator/id/money-zakat/',
    },
    {
      title: 'Hitung dan Konversi IPK Universitas Anda',
      url: '/calculator/id/gpagrade/',
    },
  ];
  return (
    <div style={{ margin: '20px 0' }}>
      <b style={{
        display: 'block',
        marginBottom: '15px',
        fontSize: '16px',
        color: '#1a5f3f',
        fontFamily: 'Tajawal, sans-serif'
      }}>
        Kalkulator yang mungkin menarik bagi Anda:
      </b>
      <div className="related-links-container" style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        marginTop: '10px'
      }}>
        {relatedLinks.map((link, index) => (
          <a
            key={index}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-secondary btn-sm"
            style={{
              marginBottom: '8px'
            }}
          >
            {link.title}
          </a>
        ))}
      </div>
    </div>
  );
};
export default RelatedLinks;